<template>
  <div id="app">
    <app-header v-if="isAuthorized" />
    <router-view :key="pageKey" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AppHeader from '@/components/common/AppHeader.vue';

export default {
  name: 'App',
  components: {
    AppHeader,
  },
  computed: {
    ...mapState(['pageKey', 'isAuthorized']),
  },
};
</script>
